import React, {useCallback, useEffect, useMemo, useRef, useState} from 'react';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import Step1 from './steps/Step1.js';
import Step2 from './steps/Step2.js';
import { Box, Typography } from '@mui/material';
import DsasButton from '../../../../v1/components/DsasButton/DsasButton.js';
import { faArrowRotateRight, faCancel, faCheck, faInfoCircle } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';


const LivePopupCreator = ({open, setOpen, state, setState, handleConfirm, handleInit, initialState}) => {
    const [currentStep, setCurrentStep] = useState(1);

     const prevOpenRef = useRef(open);

  useEffect(() => {
    const wasOpen = prevOpenRef.current;
    if (wasOpen && !open) {
      handleInit?.();
      setCurrentStep(1);
    }
    prevOpenRef.current = open;
  }, [open, handleInit]);
    

     const handleStep1Submit = useCallback((formData) => {
    setState(prev => ({ ...prev, ...formData }));
    setCurrentStep(2);
  }, [setState]);

  const handleStep2Submit = useCallback((formData) => {
    setState(prev => ({ ...prev, ...formData }));
  }, [setState]);

  const handleStepBack = useCallback(() => {
    setCurrentStep(s => s - 1);
  }, []);

  const handleCancel = useCallback(() => {
    setOpen(false);
  }, [setOpen]);

    const handleClear = useCallback(() => {
      const cloned = typeof structuredClone === 'function'
        ? structuredClone(initialState)
        : JSON.parse(JSON.stringify(initialState));

      setState(cloned);
      setCurrentStep(1);
    }, [initialState, setState]);

    const isSaveDisabled = useMemo(() => {
      return  !state.dateTime || 
              !state.provider ||
              !state.name ||
              ((!state.matchs || !state.matchs.length) && (!state.competitionDetails ||
              !state.competitionDetails.length ||
              state.competitionDetails.find(c => !c.competition || !c.teams || !c.teams.length || (!c.homeMatches && !c.awayMatches))))   
    }, [state])

    return (
      <Dialog open={open} fullWidth maxWidth={"lg"}>
        <Typography variant="caption"
          sx={{backgroundColor: 'var(--color-light-grey)',
            padding: {
              xs: '2px',      
              sm: '8px'
            },
            width: "fit-content",
            alignSelf: 'end',
            fontWeight: 'normal',
            position: 'absolute'
          }}
        >Etape {currentStep}/2</Typography>
        <Box className='centered-wrapper padding-wrapper' sx={{
          paddingTop: {
            xs: '20px',  // Mobile
          }
        }}>
          <Typography variant="h1" className='page-title'>Création de direct</Typography>
        </Box>
        
        <Box className='large-separator'></Box>

          {/**POPUP BODY CONTENT*/}
            <DialogContent sx={{padding:'2rem', paddingTop:0, paddingBottom:0}}>
              {/**INFOS*/}
              {currentStep && currentStep===1 && 
              <>
              <Box className='medium-padding large-padding-left large-padding-right' sx={{display: 'flex', alignItems: 'flex-start'}}>
              <Box sx={{padding:0, paddingRight:'8px'}}>
                <FontAwesomeIcon icon={faInfoCircle} style={{
                      color: 'var(--color-dark-grey)'
                    }}/>
              </Box>
              <Box sx={{display: 'flex', flexDirection: 'column'}}>
                <Typography variant='caption'>
                  Vous pouvez créer un direct en deux étapes. 
                </Typography>
                <Typography variant='caption'>
                  La première étape consiste à renseigner les informations de base du direct, la seconde étape vous permet de sélectionner les matchs à suivre.
                </Typography>
              </Box>
            </Box>
            <Box className='large-separator'></Box>
            </>
            }

            {/**FORM*/}
            <Box className='large-padding-left large-padding-right'>
            {currentStep === 1 && (
              <Step1
                isEditMode={state.isEditMode}
                state={state}
                setState={setState}
                onSubmit={handleStep1Submit}
              />
            )}
            {currentStep === 2 && (
              <Step2
                state={state}
                onSubmit={handleStep2Submit}
                onBack={handleStepBack}
              />
            )}
            </Box>
            </DialogContent>

            <Box className='large-separator'></Box>
            <DialogActions sx={{justifyContent:'center'}}>
            <Box className='centered-wrapper'>
             <DsasButton icon={faArrowRotateRight} label="Reset" onClick={handleClear} variant="secondary" />
              <DsasButton icon={faCancel} label="Annuler" onClick={handleCancel} variant="secondary" />
              <DsasButton icon={faCheck} label={`${state.isEditMode ? 'Modifier' : 'Enregistrer'} le direct`} onClick={handleConfirm} disabled={isSaveDisabled} variant = 'secondary'/>
            </Box>
            </DialogActions>
        </Dialog>
    )
}

export default LivePopupCreator